// @charset "UTF-8";
import { Box, Card, CardContent, CardHeader, CircularProgress, Container, Grid, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { I18nContext } from "../../I18nProvider";
import { Centro } from "../../Interface/ICentro";
import IresearhService from "../../services/IresearchService";

export const CentroDeInvestigacion: React.FC<{}> = () => {
    
    const [centros, setCentros] = useState<Centro[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const context = useContext(I18nContext);

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    useEffect(() => {
        IresearhService.getUnidades()
            .then((unidadesData: { listData: Centro[] }) => {
                const centrosInvestigacion = unidadesData.listData.filter((unidad) => unidad.idtipounidad === 8);
                setCentros(centrosInvestigacion);

            })
            .catch((error) => {
                console.error("Error fetching user data from backend:", error);
            })
            .finally(() => {
                setLoading(false); 
            });
    }, []);

    

    return (
		<Container>
            <h1>{context.t.translate("home.cInvestigacion")}</h1>

            {loading ? ( 
                <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                    <CircularProgress />
                </Box>
            ) : (
            <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={10} md={10} container spacing={8} justifyContent="center"   >
                    {centros.map((item) => {
                        const centro_url = `/centro/${item.siglas.toLowerCase()}`
                        return (
                            <Grid item xs={12} sm={6} md={4} key={item.idunidad}>
                                <Link to={ centro_url} style={{ textDecoration: 'none' }}>
                                <Card sx={{ width: '100%', height: 200, display: 'flex', flexDirection: 'column' }}>
                                        <CardHeader sx={{ backgroundColor: item.color || "#243165", height: 40 }}
                                            title={
                                                <Typography sx={{ color: item.siglas.trim() === "CENAIM" ? "black !important" : "white" }}>
                                                    {item.siglas}
                                                </Typography>
                                            }
                                        />
                                    <CardContent sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Typography variant="body1" align="center">
                                            {item.nombreunidad}
                                        </Typography>
                                    </CardContent>
                                </Card>
                                </Link>
                            </Grid>

                        );
                    })}

                </Grid>
            </Grid>
            )}

		</Container>
	)
}